var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item d-flex",class:("size-" + _vm.size)},[_c('div',{staticClass:"label flex-shrink-0 d-flex align-center"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"content flex-grow-1"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }